exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".service-update{border-bottom:1px solid #d6d6d6;margin-bottom:1rem}.service-update:last-child{border-bottom:none}", "", {"version":3,"sources":["/./src/app/components/serviceUpdatesModal/src/app/components/serviceUpdatesModal/serviceupdatesmodal.scss"],"names":[],"mappings":"AAAA,gBACE,gCAAgC,AAChC,kBAAmB,CAIpB,AAND,2BAII,kBAAmB,CACpB","file":"serviceupdatesmodal.scss","sourcesContent":[".service-update {\n  border-bottom: 1px solid #d6d6d6;\n  margin-bottom: 1rem;\n  &:last-child {\n    border-bottom: none;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/serviceUpdatesModal/serviceupdatesmodal.scss
// module id = 912
// module chunks = 0